import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SavedCompanyUserWrapper = lazy(() =>
  import("@scenes/PermissionSettings/components/CompanyUserManagement/SavedCompanyUserWrapper").then((module) => ({
    default: module.SavedCompanyUserWrapper,
  }))
);

export const savedCompanyUserNRO: NavigationRoutingObject = {
  Component: SavedCompanyUserWrapper,
  componentFeatureFlippers: ["unified_permission_settings_page"],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("saved-company-user-nro-heading", "Edit Company User"),
  pageNameForTracking: () => "Edit Company User",
  getDeveloperNavigationAllowed: ({ hasPermissionForAnyScope, isFreeTrial, featureOn }) => {
    // Please keep this in sync with the logic in the SettingsMenuItems component

    if (isFreeTrial) {
      return hasPermissionForAnyScope("viewFreeTrialDevelopers");
    }

    if (
      featureOn("clip_granular_permission_manage_developers_and_permissions") &&
      featureOn("clip_granular_permissions_all")
    ) {
      return hasPermissionForAnyScope("editDashboardUsers");
    }

    return hasPermissionForAnyScope("manageDevelopersAndPermissions");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/user_management/company_users/:appGroupId",
};
